import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { SvgIconComponent } from '@ngneat/svg-icon'
import { CoreFeatureModule } from '@lla-platform/core/core-feature'
import { PublicLayoutComponent } from './public-layout/public-layout.component'

@NgModule({
  declarations: [PublicLayoutComponent],
  imports: [CommonModule, RouterModule, SvgIconComponent, CoreFeatureModule],
  exports: [PublicLayoutComponent]
})
export class PublicLayoutModule {}
